import { Component } from "@angular/core";

@Component({
  selector: "animated-x-btn",
  templateUrl: "./animated-x-btn.component.html",
  styleUrls: ["./animated-x-btn.component.scss"],
})
export class AnimatedXButtonComponent {
  constructor() {}
}
